<template>
  <div class="icons">
    <transition-group appear name="slide-fade">
      <div :key="0" class="columns is-multiline">
        <div class="column is-two-thirds-desktop is-full-width-tablet icon-columns">
          <div class="columns is-variable is-8">
            <div v-for="(item, index) in slice.items" :key="item.id" class="column is-one-third icon-column">
              <div v-scroll-reveal="{ delay: 30 + (75 * index) }" class="icon-image load-hidden desktop-icons">
                <prismic-image :field="item.icon_image" width="150" height="150"/>
              </div>
              <div v-scroll-reveal="{ delay: 0 }" class="icon-image load-hidden mobile-icons">
                <prismic-image :field="item.icon_image" width="150" height="150"/>
              </div>
              <div class="caption">
                <prismic-rich-text :field="item.icon_caption"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'IconRow',
  props: ['slice']
}
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "../../assets/sass/colors.scss";

.highlight {
  position: relative;
  overflow: auto;
}
.highlight-left {
  width: 43%;
  float: left;
}
.highlight-right {
  width: 48%;
  float: right;
}
.icon-column {
  .desktop-icons {
    display: block;
  }
  .mobile-icons {
    display: none;
  }
  @media screen and (max-width: $tablet) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .desktop-icons {
      display: none;
    }
    .mobile-icons {
      display: block;
    }
    .icon-image {
      flex: 0 0 25%;
    }
    .caption {
      flex: 0 0 65%;
    }
  }
}
/* Media Queries */
@media (max-width: 767px) {
  .highlight-left,
  .highlight-right {
    width: 100%;
    float: none;
  }
}
</style>
